module.exports = __webpack_public_path__ + "media/images/mobile/login-755063de9889690e043a54c593014cc7.svg";